import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddDisplay = createAsyncThunk(
  "other/AddDisplay",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/display-create/`, data)
    return response.data
  }
); 

export const UpdateDisplay = createAsyncThunk(
  "other/UpdateDisplay",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/display-update/${data.id}/`, data)
    return response.data
  }
);

export const GetDisplayList = createAsyncThunk(
  "user/GetDisplayList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/display-list/`)
    return data
  }
);

export const DeleteDisplay = createAsyncThunk(
  "other/DeleteDisplay",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/display-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

